<template>
  <div class="demo-spin-article">
    <div class="ls_action_header">
      <Row type="flex" justify="space-between" class="ls_action_header mb-50" style="padding-top: 5px">

        <Col>
          <Button type="info">Скачать отчет</Button>
        </Col>

        <Col>
          <Select
            style="width: 200px"
            placeholder="Список отчетов"
          >
            <Option
              value="period_report"
            >Отчет 1
            </Option>
            <Option
              value="period_ticket_report"
            >Отчет 2
            </Option>
          </Select>
        </Col>

        <!-- TEXT SEARCH -->
        <Col style="justify-content: space-between; display: flex; align-items: center">
          <Button
            type="primary"
            class="ls_bulk_delete_button font-bold"
            @click="showGroupModal=true"
          >
            {{ groupButtonName }}
            <Icon type="ios-arrow-down" />
          </Button>
          <Modal
            v-model="showGroupModal"
            @on-cancel=""
            title="Выберите группу товаров"
          >
            <!--<div style="margin-top: 25px;">-->
            <!--<Input search placeholder="Введите название группы" />-->
            <Tree
              :data="groupData"
              :load-data="fetchChildrenGroups"
              @on-select-change="selectGroup"
            ></Tree>
            <!--</div>-->
            <div slot="footer">
              <Button  type="error" size="large" @click="showGroupModal=false">Отменить</Button>
            </div>
          </Modal>
        </Col>

        <Col>
          <Select
            style="width: 200px"
            placeholder="Список магазинов"
          >
            <Option
              v-for="item in store"
              :value="item.id"
              :key="item.id"
            >
              {{ item.name }}

            </Option
            >
          </Select>
        </Col>

        <Col>
          <DatePicker
            @on-change="changeFilterOrderDate"
            @on-clear="clearFilterOrderDate"
            format="dd.MM.yyyy"
            type="date"
            split-panels
            placeholder="Дата документа"
            style="width: 200px"
          ></DatePicker>
        </Col>

      </Row>


      <!-- FILTER -->
      <Row :gutter="10" type="flex" justify="center" v-show="filterShow" style="margin-bottom: 24px">
        <!-- BULK DELETE -->
        <Col span="10">
          <!-- BULK ACTIONS-->
          <Button
            v-if="selected.length != 0"
            type="error"
            class="ls_bulk_delete_button"
            @click="bulkDelete"
          >Удалить
          </Button>
          <div v-else style="padding: 1px"></div>
        </Col>
        <Col
          span="14"
        ><Select
          v-model="filter.type"
          style="width:130px"
          clearable
          placeholder="Тип"
        ><Option
          v-for="item in filterOptions.type"
          :value="item.value"
          :key="item.value"
        >{{ item.label }}</Option
        >
        </Select></Col
        >
      </Row>
    </div>
    <!-- DATA TABLE + PAGINATION -->
    <Table
      :loading="loading"
      :columns="columns"
      :data="data"
      @on-sort-change="changeSorting"
      @on-selection-change="onSelectChange"
    ></Table>
    <Page
      :total="totalRecords"
      :page-size="pageSize"
      :page-size-opts="[15, 25, 35]"
      @on-change="changePage"
      @on-page-size-change="changePageSize"
      show-sizer
      :styles="{ marginTop: '30px', float: 'right' }"
    />

    <!-- ITEM VIEW -->
    <catalogItem
      :id="item.id"
      :action="item.action"
      v-model="item.show"
      @reload-table="fetchItems"
      :base_view_url="baseViewUrl"
      :item_type="item_type"
    ></catalogItem>
  </div>
</template>
<script>
    import { base_url } from "../../http.js";
    import { formatNumber } from "../../base/base_func.js";
    import { BaseTableData } from "../../base/base_table.js";
    import catalogItem from "@/apps/catalog/catalogItem.vue";

    let _app = BaseTableData();
    _app.components = {
        catalogItem
    };

    _app.data = function() {
        return {
            // Base settings
            baseViewUrl: base_url + "/catalog/products/",
            item_type: "catalog",
            loading: true,

            //currency: localStorage.getItem('currency'),

            // Table settings
            columns: [
                {
                    title: "Наименование",
                    width: 340,
                    key: "name",
                },


                {
                    title: "Код",
                    // width: 150,
                    // maxWidth: 140,
                    key: "barcode",
                    sortable: true,
                    align: "center"
                },
                {
                    title: "Артикул",
                    // width: 150,
                    // maxWidth: 140,
                    key: "sku",
                    sortable: true,
                    align: "center"
                },
                {
                    title: "Ед.изм.",
                    // width: 60,
                    key: "unit",
                    sortable: true,
                    // width: 100,
                    align: "center"
                },
                {
                    title: "Базовая цена",
                    // width: 90,
                    key: "base_price",
                    sortable: true,
                    // width: 150,
                    align: "right",
                    render: (h, params) => {
                        // return h("span", {}, formatNumber(params.row.purchase) + ' ' + this.currency);
                        return h("span", {}, formatNumber(params.row.base_price) + ' ' + this.currency);
                    }
                },
                // {
                //   title: "Цена продажи за ед.",
                //   // width: 90,
                //   key: "base_price",
                //   sortable: true,
                //   // width: 150,
                //   align: "right",
                //   render: (h, params) => {
                //     return h("span", {}, formatNumber(params.row.base_price) + ' ' + this.currency);
                //   }
                // },
                {
                    title: "Скидка",
                    // width: 100,
                    key: "discount",
                    sortable: true,
                    align: "center",
                    render: (h, params) => {
                        return h("span", {}, params.row.discount + ' %');
                    }
                }
            ],
            data: [],
            lastDraw: 0,
            totalRecords: null,
            currentPage: 1,
            pageSize: 15,
            sorting: "",
            searchString: "",
            // showClearFilter: false,

            filterShow: false,
            filter: {
                type: "",
                // store: ""
                // applied: "",
                // order_date__gt: "",
                // order_date__lt: "",
                group: ""
            },
            filterOptions: {
                type: [
                    {
                        value: "PRODUCT",
                        label: "Продукт"
                    },
                    {
                        value: "SERVICE",
                        label: "Услуга"
                    },
                    {
                        value: "KIT",
                        label: "Комплект"
                    }
                ],
                // store: []
                // applied: [
                //   {
                //     value: "true",
                //     label: "Проведен"
                //   },
                //   {
                //     value: "false",
                //     label: "Не проведен"
                //   }
                // ],
            },

            filterOrderDate: ["", ""],
            selected: [],

            store: [],

            item: {
                show: false,
                id: null,
                action: null
            },

            loadedGroups: false,
            showGroupModal: false,
            groupData: [],
            selectedGroupName: ""
        };
    };

    _app.computed.groupButtonName = function(){
        return (this.selectedGroupName&&this.filter.group) ? this.selectedGroupName : "Выбрать группу";
    };
    // _app.computed.display_edit_button = function() {
    //   return (
    //     this.permissions.indexOf("catalog.product_update_all") !== -1 ||
    //     this.permissions.indexOf("catalog.product_update_owner") !== -1
    //   );
    // };
    _app.computed.display_delete_button = function() {
        return (
            this.permissions.indexOf("catalog.product_delete_all") !== -1 ||
            this.permissions.indexOf("catalog.product_delete_owner") !== -1
        );
    };
    _app.computed.display_create_button = function() {
        return (
            this.permissions.indexOf("catalog.product_create") !== -1
        );
    };

    _app.methods.display_edit_button_by_row = function(row) {
        if ('can_update' in row) {
            return (row.can_update && (
                this.permissions.indexOf("catalog.product_update_all") !== -1 ||
                this.permissions.indexOf("catalog.product_update_owner") !== -1
            ));
        }
        return (
            this.permissions.indexOf("catalog.product_update_all") !== -1 ||
            this.permissions.indexOf("catalog.product_update_owner") !== -1
        );
    };

    _app.methods.display_delete_button_by_row = function(row) {
        if ('can_delete' in row) {
            return (row.can_delete && (
                this.permissions.indexOf("catalog.product_delete_all") !== -1 ||
                this.permissions.indexOf("catalog.product_delete_owner") !== -1
            ));
        }
        return (
            this.permissions.indexOf("catalog.product_delete_all") !== -1 ||
            this.permissions.indexOf("catalog.product_delete_owner") !== -1
        );
    };


    // Переключения режима "Доп.фильтр"
    _app.methods.toogleFilter = function(val) {
        this.filterShow = val;

        // Если убираем фильтр - очищаем все поля фильтра
        if (!val) {
            for (let key in this.filter) {
                this.filter[key] = "";
            }

            // Дополнительная очистка фильтров (Даты документа)
            this.filterOrderDate = [];
        }
    };

    // Очистка фильтров
    _app.methods.clearFilter = function() {
        // Очистка общих фильтров и посика
        if (this.searchString) {
            this.searchString = "";
        }
        for (let key in this.filter) {
            if (this.filter[key]) {
                this.filter[key] = "";
            }
        }

        // Дополнительная очистка фильтров (Даты документа)
        this.filterOrderDate = [];

        // Перезагрузка групп
        this.loadedGroups = false;
    };

    _app.methods.changeFilterOrderDate = function(date_arr, date_obj) {
        if (date_arr[0] && date_arr[1]) {
            this.filter.order_date__gt = this.filterOrderDate[0];
            this.filter.order_date__lt = this.filterOrderDate[1];

            // this.filter.order_date__gt = date_arr[0] + 'T00:00:00';
            // this.filter.order_date__lt = date_arr[1] + 'T00:00:00';
        }
    };

    // Очистка полей поиска даты документа (Order date), после чего срабатывает watcher и обновляются данные в таблице
    _app.methods.clearFilterOrderDate = function(date_arr, date_obj) {
        this.filter.order_date__gt = "";
        this.filter.order_date__lt = "";
    };

    _app.methods.fetchGroups = function() {
        const url = base_url + "/catalog/groups/?parent=true";
        this.$http
            .get(url)
            .then(result => {
                if (result.data.results) {
                    this.groupData = [];
                    for (const item of result.data.results) {
                        let item_data = {
                            id: item.id,
                            title: item.name,
                            // loading: false,
                        };
                        if (item.has_children) {
                            item_data.children = [];
                            item_data.loading = false;
                        }
                        this.groupData.push(item_data);
                    }
                    this.loadedGroups = true;
                }
            })
    };

    _app.methods.fetchChildrenGroups = function (item, callback){
        const url = base_url + `/catalog/groups/${item.id}/children/`;
        this.$http
            .get(url)
            .then(result => {
                if (result.data.results) {
                    let data = [];
                    for (const item of result.data.results) {
                        let item_data = {
                            id: item.id,
                            title: item.name,
                        };
                        if (item.has_children) {
                            item_data.children = [];
                            item_data.loading = false;
                        }
                        data.push(item_data);
                    }
                    callback(data);
                }
            })
    };

    _app.methods.selectGroup = function (item, callback){
        this.showGroupModal = false;
        this.filter.group = item[0].id;
        this.selectedGroupName = item[0].title;
    };



    _app.watch['showGroupModal'] = function() {
        if (!this.loadedGroups) this.fetchGroups();
    };

    _app.methods.getStore = function() {
        const url = base_url + "/stores/";
        this.$http
            .get(url)
            .then(result => {
                this.store = result.data.results;
            })
    };

    _app.created = function() {
      this.getStore();
    };


    export default _app;

</script>


<style>
  ul.ivu-tree-children .ivu-tree-title{
    font-size: 16px;
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/apps/report/productsAndService.vue